import { render, staticRenderFns } from "./ChartMedianNumbersByPerson.vue?vue&type=template&id=0d170964"
import script from "./ChartMedianNumbersByPerson.vue?vue&type=script&lang=js"
export * from "./ChartMedianNumbersByPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports